<template>
  <div class="placeholder-glow" v-if="isLoading">
    <span class="placeholder col-12 skeleton-footer"></span>
  </div>
  <div v-html="footerData.footer_content" v-else dir="ltr"></div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from "vue";
import LayoutService from "@/services/layout";
import handleError from "@/helper/handleError";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "MainFooter",
  setup() {
    interface Social {
      url: string;
      image: string;
    }
    interface Policy {
      name: string;
      enabled: Boolean;
      url: string;
    }
    const footerData = ref({
      footer_logo: String,
      social_media_links: [] as Social[],
      policies: [] as Policy[],
      footer_content: String,
    });
    const route = useRoute();
    // Prefer the URL over localStorage, and resolve it reactively:
    //  - localStorage holds the LAST product opened, not the one in ?productID=,
    //    so a stale id rendered another product's footer on this page.
    //  - vue-router's initial navigation is async, so route.query is still empty
    //    while setup() runs; reading it once left this undefined on a direct link.
    const productID = computed(
      () => (route.query.productID as string) || localStorage.getItem("productID") || ""
    );
    const isLoading = ref(true);
    // ===================== Methods ===============
    const getFooter = () => {
      isLoading.value = true;
      if (!productID.value) return; // Avoid making a request if productID is undefined
      LayoutService.getFooter(productID.value)
        .then((response) => {
          isLoading.value = false;
          footerData.value = response.data.data;
        })
        .catch((err: any) => {
          isLoading.value = false;
          handleError(err);
        });
    };

    // ================== watch ====================
    watch(productID, getFooter, { immediate: true });

    return {
      footerData,
      getFooter,
      productID,
      isLoading,
    };
  },
});
</script>
<style lang="scss">
.fixed-buy-now-container {
  display: none;
}
</style>
<style lang="scss" scoped>
.skeleton-footer {
  min-height: 4em;
}
</style>

